/*
 * trpc (provider)
 */
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import type { CreateTRPCReact } from "@trpc/react-query"
import type { AnyRouter } from "@trpc/server"
import type { ReactNode } from "react"
import { TrpcContext } from "./trpc.context"

export type TrpcProviderProps<TRouter extends AnyRouter> = {
	trpc: CreateTRPCReact<TRouter, any>
	trpcClient: any
	queryClient: QueryClient
	children: ReactNode
}

export function TrpcProvider<TRouter extends AnyRouter>({
	trpc,
	trpcClient,
	queryClient,
	children,
}: TrpcProviderProps<TRouter>) {
	const TrpcReactProvider = (trpc as any).Provider

	return (
		<TrpcContext.Provider value={trpc}>
			<TrpcReactProvider client={trpcClient} queryClient={queryClient}>
				<QueryClientProvider client={queryClient}>
					{children}
				</QueryClientProvider>
			</TrpcReactProvider>
		</TrpcContext.Provider>
	)
}
